/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * @implements {NetworkManager}
 */
class GeneratorNetworkManager {
  /** Vytvoří instanci. */
  constructor () {
    this.connectionArray = [];
  }

  /** @inheritdoc */
  destroy () {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @inheritdoc */
  getAllConnections () {
    return new Promise((resolve) => resolve(
      this.connectionArray
    ));
  }

  /** @inheritdoc */
  isOnline () {
    return new Promise(() => {
      throw new Error('Not implemented.');
    });
  }

  /** @inheritdoc */
  off (type, callback) {
    throw new Error('Not implemented.');
  }

  /** @inheritdoc */
  on (type, callback) {
    throw new Error('Not implemented.');
  }

  /**
   * @param {Array.<NetworkConnection>} connectionArray Seznam připojení.
   * @returns {undefined}
   */
  setAllConnections (connectionArray) {
    this.connectionArray = connectionArray;
  }
}

export default GeneratorNetworkManager;
